import { API_LOCATION_URL } from 'infrastructure/config';
import {
    IPostInput,
    IPostResponse,
    ICompanyUserProfileRegistrationClient,
} from 'interfaceAdapter/gatewaySchemas/ICompanyUserProfileRegistrationClient';
import { getCookie } from 'utils/cookie';

const csrfToken = getCookie('csrftoken');
const PATH = `${API_LOCATION_URL}/company/registration/user_profile`;

export class CompanyUserProfileRegistrationClient implements ICompanyUserProfileRegistrationClient {
    async post(input: IPostInput): Promise<IPostResponse> {
        const { token, company_user } = input;
        const method = 'POST';
        const headers: { [key: string]: string } = {
            'Content-Type': 'application/json',
            'X-HTTP-AUTH-TOKEN-C': token,
        };

        if (csrfToken) {
            headers['X-CSRFToken'] = csrfToken;
        }
        const body = JSON.stringify(company_user);

        try {
            const response = await fetch(PATH, {
                method,
                headers,
                body,
            });

            return await response.json();
        } catch {
            throw new Error('処理に失敗しました');
        }
    }
}
